import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';

import { CreateUserRequestDto, UpdateUserRequestDto, UserResponseDto, UsersPaginationResponseDto } from './users.dto';
import { UsersTableFilters } from './users.types';

export class UsersApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/users');
  }

  public async getAllUsers(filters: UsersTableFilters) {
    const params = new URLSearchParams();

    params.append('offset', filters.offset.toString());
    params.append('count', filters.count.toString());
    params.append('sortFiled', filters.sortField);
    params.append('sortDirection', filters.sortDirection);

    return await this.instance
      .get('/', { params: params })
      .then((response: AxiosResponse<UsersPaginationResponseDto>) => response.data);
  }

  public async getUserById(userId: number) {
    return await this.instance.get(`/${userId}`).then((response: AxiosResponse<UserResponseDto>) => response.data);
  }

  public async createUser(user: CreateUserRequestDto) {
    return await this.instance.post('/', user).then((response: AxiosResponse<void>) => response.data);
  }

  public async update(userId: number, updatedUser: UpdateUserRequestDto) {
    return await this.instance.put(`/${userId}`, updatedUser).then((response: AxiosResponse<void>) => response.data);
  }

  public async delete(userId: number) {
    return await this.instance.delete(`/${userId}`).then((response: AxiosResponse<void>) => response.data);
  }

  public async resendInvitation(userId: number) {
    return await this.instance
      .post(`/resend-invitation/${userId}`)
      .then((response: AxiosResponse<void>) => response.data);
  }
}
